"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ItemInfo = _interopRequireDefault(require("../ItemInfo"));

var User = function User(_ref) {
  var name = _ref.name,
      picture = _ref.picture,
      email = _ref.email,
      style = _ref.style,
      className = _ref.className,
      size = _ref.size,
      hideEmail = _ref.hideEmail,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["name", "picture", "email", "style", "className", "size", "hideEmail"]);
  return _react.default.createElement(_ItemInfo.default, (0, _extends2.default)({
    name: name,
    picture: picture,
    info: email,
    hideInfo: hideEmail,
    style: style,
    size: size,
    className: className
  }, otherProps));
};

User.propTypes = (0, _objectSpread2.default)({}, _ItemInfo.default.propTypes, {
  name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
  picture: _propTypes.default.string.isRequired,
  email: _propTypes.default.string,
  size: _propTypes.default.oneOf(['large', 'medium', 'small']),
  hideEmail: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object
});
User.defaultProps = {
  email: '',
  size: 'large',
  hideEmail: false,
  className: '',
  style: {}
};
var _default = User;
exports.default = _default;